import axios from 'axios';

// Detectar automáticamente la URL de la API
// En producción con subdominios separados, usar URL absoluta del API
const getApiUrl = () => {
  // Si hay una variable de entorno definida, usarla (tiene prioridad)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // En producción, usar subdominio de API
  if (process.env.NODE_ENV === 'production') {
    // Por defecto: api.runniaapp.com/api
    // Puedes cambiarlo configurando REACT_APP_API_URL en el .env
    return 'https://api.runniaapp.com/api';
  }
  
  // En desarrollo, usar localhost
  return 'http://localhost:8000/api';
};

const API_URL = getApiUrl();

// Crear instancia de axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Configurar interceptor para incluir el token en todas las peticiones
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // No establecer Content-Type si es FormData (el navegador lo hará automáticamente)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
